import { useSelector } from "react-redux";

export const useGlobal = () => {
    return useSelector((state) => state.global);
};
